import { createFileRoute } from '@tanstack/react-router'
import { GitBranch } from 'lucide-react'
import { z } from 'zod'
import { BranchesScreen } from '@/screens/investigate/SCR-023-branches'

export const Route = createFileRoute('/_app/w/$ws/branches')({
  staticData: { screen: { id: 'SCR-023', title: 'Branches', group: 'Investigate', perm: 'branch.manage', order: 10, description: 'Try memory changes safely, then merge or discard them.', icon: GitBranch } },
  validateSearch: z.object({ status: z.enum(['open', 'merged', 'discarded', 'expired', 'all']).optional().catch(undefined) }),
  component: BranchesScreen,
})
